import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import TextInput from '../../Shared/TextInput/TextInput';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {
    validateUserBeforeResetParentalCode,
    setParentalCodeStep,
    saveToHistory,
    setValidateUserAndCard,
} from '../TvActivationCodeRecoveryBlock/TvActivationCodeRecoveryBlockSlice';
import {Step} from './ResetParentalCodeEnum';
import {parentalControlReport} from './ParentalControlReports';

const VerifyTVInfo = (props) => {
    const [id, setId] = useState('');
    const [card, setCard] = useState('');
    const textRow1 = 'שכחתם את הקוד?';
    const textRow2 = 'לאיפוס הקוד אנא הזינו את פרטי הזיהוי הבאים';
    const textRow2Mobile = 'לאיפוס הקוד אנא הזינו את פרטי';
    const textRow3Mobile = 'הזיהוי הבאים';

    const [error, setError] = useState(null);
    const errorMsg = 'אחד או יותר מהנתונים שהוזנו אינם תואמים';
    useEffect(() => {
        props.saveToHistory('verify-tv-account');
    }, []);

    const handleId = (event) => {

        setId(event.target.value);
    };

    const handleCard = (event) => {
        setCard(event.target.value);
    };


    useEffect(() => {
        if (props.validateUserAndCard != null && props.validateUserAndCard == true) {
            setError(false);
            props.setParentalCodeStep(Step.RESET_CODE);
        } else if (props.validateUserAndCard != null && props.validateUserAndCard == false) {
            setError(true);
            parentalControlReport('Verification Page', 'Validation', 'Verification Failed Wrong Details', props.account?.username, props.userData?.firstName
                + ' ' + props.userData?.lastName, props.userData?.IDNumber, id, card);
        }
    }, [props.validateUserAndCard]);


    const handleClick = () => {
        let data = {
            id: id,
            card: card,
            externalAssetId: props.account?.assetExternalId,
        }
        props.validateUserBeforeResetParentalCode(data);


        parentalControlReport('Verification Page', 'Ongoing', 'Verification Page Button Clicked', props.account?.username, props.userData?.firstName
            + ' ' + props.userData?.lastName, props.userData?.IDNumber, id, card);

    };

    useEffect(() => {
        setError(null);
        if (props.validateUserAndCard != null) {
            props.setValidateUserAndCard(null);
        }
    }, [id, card]);


    useEffect(() => {
        parentalControlReport('Verification Page', 'Ongoing', 'Verification Page Displayed', props.account?.username, props.userData?.firstName
            + ' ' + props.userData?.lastName, props.userData?.IDNumber, '', '');
    }, [])

    return (
        <div className='verify-tv-info'>

            <div style={{marginBottom: "40px"}}>
                {!isMobile ? <div>
                        <div className='text'>{textRow1}</div>
                        <div className='text'>{textRow2}</div>
                    </div> :
                    <div>
                        <div className='text'>{textRow1}</div>
                        <div className='text'>{textRow2Mobile}</div>
                        <div className='text'>{textRow3Mobile}</div>
                    </div>
                }
            </div>
            <TextInput
                placeholder='מספר ת.ז של בעל הכרטיס'
                name='code'
                onChange={handleId}
                required='required'
                error={error ? errorMsg : ''}
                maxLength='9'
                onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                    }
                }}
            />
            <TextInput
                placeholder='4 ספרות אחרונות של אמצעי התשלום'
                name='code'
                onChange={handleCard}
                required='required'
                error={error ? errorMsg : ''}
                maxLength='4'
                onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                    }
                }}
            />
            {error != null && error &&
                <div style={{marginBottom: "-10px"}} className='error-msg'>
                    {errorMsg}
                </div>
            }
            <div style={{marginTop: error ? '-20px' : ''}}>
                <BtnSubmit
                    text={'אישור וממשיכים'}
                    onclick={handleClick}
                />
            </div>

        </div>
    );

};

const mapStateToProps = (state) => {
    return {
        validateUserAndCard: state.TvActivationCodeRecovery?.validateUserAndCard,
        account: state.TvActivationCodeRecovery?.currentParrentalCodeAccount,
    };
};

const mapDispatchToProps = {
    validateUserBeforeResetParentalCode,
    setParentalCodeStep,
    saveToHistory,
    setValidateUserAndCard,
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyTVInfo);
